import styled, { css } from "styled-components";
import { generic as sg } from "../../../../../ui/_themes/constants";
import * as h from "../../../../../ui/_themes/helpers";

interface IIndicator {
  numOfTabs: number;
}

export const menuIndicatorPosition = props => {
  if (props.active) {
    return css`
      @media (orientation: landscape) {
        & ~ hr {
          top: ${(100 / props.numOfTabs) * props.index}%;
        }
      }

      @media (orientation: portrait) {
        & ~ hr {
          left: ${(100 / props.numOfTabs) * props.index}%;
        }
      }
    `;
  }
};

export const Indicator = styled<IIndicator, "hr">("hr")`
  background: ${h.getColor(
    "menuNavButtonActiveIndicator",
    "menu.navButton.activeIndicator"
  )};
  display: block;
  position: absolute;
  z-index: ${sg.layers.game + 1};
  margin: 0;
  border: none;

  @media (orientation: landscape) {
    height: ${props => 100 / props.numOfTabs}%;
    width: 0.1em;
    transition: top 200ms ease;
  }

  @media (orientation: portrait) {
    width: ${props => 100 / props.numOfTabs}%;
    height: 4%;
    transition: left 200ms ease;
    bottom: 0;
  }
`;
